/**
 * Brand artwork used for page backgrounds and blog covers.
 * AI-generated, brand-matched (mint + gold) abstract art — no stock photos,
 * so every public surface has a backdrop even with no admin-set image.
 */
export const ART = {
  hero: "https://static.prod-images.emergentagent.com/jobs/b3bf9969-84d6-4a30-9c96-a8544413e536/images/8fc427fe1b93752165bf53d563da27c780a3e3c647500157fca5044adc240c65.jpeg",
  soft: "https://static.prod-images.emergentagent.com/jobs/b3bf9969-84d6-4a30-9c96-a8544413e536/images/893df78df9a4b42ae9118932f23dfff9b52f0139e683f656e79b8fea5bd2dc54.jpeg",
  cta: "https://static.prod-images.emergentagent.com/jobs/b3bf9969-84d6-4a30-9c96-a8544413e536/images/08ed2d452777a2473d592a72b7745196f8dd729faf95a7812af2c8afd11c1f39.jpeg",
};

export const COVERS = [
  "https://static.prod-images.emergentagent.com/jobs/b3bf9969-84d6-4a30-9c96-a8544413e536/images/a7540056e8d011fd63e24f78ca526dc134202b83587f7607db63bc013797b65d.jpeg",
  "https://static.prod-images.emergentagent.com/jobs/b3bf9969-84d6-4a30-9c96-a8544413e536/images/76be555512c1f60048cb80b20f02519334f0998e28e83f82b8f904f6071d06dc.jpeg",
  "https://static.prod-images.emergentagent.com/jobs/b3bf9969-84d6-4a30-9c96-a8544413e536/images/d17cb8ff06a2b7214010cc040b9f8e432c21614870f71495bcbdc5f1e9d04b9f.jpeg",
  "https://static.prod-images.emergentagent.com/jobs/b3bf9969-84d6-4a30-9c96-a8544413e536/images/e8b72138236962013d11b49f791a27a874db45a4ad68e45278173882d15f660c.jpeg",
];

/** Deterministic cover per slug so a page always looks the same. */
export function coverFor(slug = "", explicit = "") {
  if (explicit) return explicit;
  let h = 0;
  for (let i = 0; i < slug.length; i += 1) h = (h * 31 + slug.charCodeAt(i)) % 9973;
  return COVERS[h % COVERS.length];
}
